<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<div class="modal-body">
								<h2 class="title">Print Epoxy Gambar</h2>

								<div class="text-center mb-3">
									<button class="btn btn-primary btn-lg" @click="print">Print</button>
									<button class="btn btn-danger btn-lg ml-3" @click="$emit('closeModal')">Batal</button>
								</div>

								<div class="mt-3 mb-3">
									
									<div v-for="(key , index) in Object.keys(woProgress)">
										<div v-if="!woProgress[key]" class="row mt-1">
											<div class="col-md-1 text-center">
												<i class="fa fa-times-circle fa-lg" style="color:red"></i>
											</div>
											<div class="col-md-8">
												<h5>{{key}}</h5>
											</div>
										</div>
									</div>
								</div>

								<div id="printEpoxy" class="border border-secondary p-10 rounded">
									<print-header></print-header>
									<hr>

									<h2 class="text-center mt-3">Gambar Epoxy</h2>


									<div>
										<template v-for="(key , index) in Object.keys(woProgress)">
											<div :key="key" class="row">
												<h5 class="col-12 pl-3" v-if="woProgress[key]">{{key}}</h5>
												<div  v-for="img in woProgress[key]" class="col-md-4 pl-3 pr-3 mt-2 mb-2">
													<img :src="env.baseImage + '/' +img" style="height:200px;width:auto;max-width:100%;" />
												</div>
											
											</div>
										</template>
										
									</div>

								</div>
								
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div> -->
			</div>
		</div>
	</transition>
</template>

<script>
import printHeader from '@/components/print/print_header.vue'
import env from '@/env'
export default {
	components : {
		printHeader
	},
	props : ['woProgress'],
	data () {
		return {
			env
		}
	},
	methods : {
		print() {
			this.$htmlToPaper('printEpoxy' , () => {
				console.log("Done")
			})
		}
	}
};
</script>

<style scoped>
td {
	font-size: 12px;
}

/* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
      #TITLE made by Colorlib (https://colorlib.com)
      ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

.companyDetails {
	margin-bottom: 5px;
	font-size: 0.6rem;
}
/* .documentTitle{
    font-size: 40px;
    border: 1px solid black;
    border-radius: 10px;
    padding:20px 30px;
  } */
.contentTitle {
	margin-top: 8px;
	font-size: 14px;
	font-weight: 700;
}
.contentVariable {
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 14px;
}
</style>
